import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDTRANSITFACILITY_LAYER_ID = 'browardTransitFacilityLayer';

const ICONS = {
  'Park and Ride Lot': require('../../../assets/park_ride_lot.png'),
  'Brightline Station': require('../../../assets/brightline_station.png'),
  'Port Everglades': require('../../../assets/port_everglades.png'),
};

const layerConfig = {
  title: 'Transit Facilities',
};

function BrowardTransitFacilityLayer() {
  const dispatch = useDispatch();
  const { browardTransitFacilityLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardTransitFacilityLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardTransitFacilityLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDTRANSITFACILITY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardTransitFacilityLayer.visible,
      opacity: browardTransitFacilityLayer.opacity,

      pointType: 'icon',
      getIcon: (d) => {
        if (d.properties.Facility_Type === 'Park and Ride Lot')
          return {
            url: ICONS['Park and Ride Lot'],
            width: 128,
            height: 128,
            anchorY: 128,
          };
        if (d.properties.Facility_Type === 'Brightline Station')
          return {
            url: ICONS['Brightline Station'],
            width: 128,
            height: 128,
            anchorY: 128,
          };
        if (d.properties.Facility_Type === 'Port Authority')
          return {
            url: ICONS['Port Everglades'],
            width: 128,
            height: 128,
            anchorY: 128,
          };
        return {
          url: ICONS['Park and Ride Lot'],
          width: 128,
          height: 128,
          anchorY: 128,
        };
      },
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDTRANSITFACILITY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Transit Facility Details',
              includeColumns: ['Facility_Type', 'Facility_Name'],
            }),
          };
        }
      },
    });
  }
}

export default BrowardTransitFacilityLayer;
